import React, { Component }  from 'react';
import {Button, Form, Input, message} from "antd";
import {fetchPost} from "../static/util/fetch";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
};

class register extends Component {
    constructor(props) {
        super(props);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleInputPhone = this.handleInputPhone.bind(this);
        this.handleInputUsername = this.handleInputUsername.bind(this);
        this.handleInputPassword = this.handleInputPassword.bind(this);
        this.handleConfirmPassword = this.handleConfirmPassword.bind(this);
        this.handleInputArea = this.handleInputArea.bind(this);
        this.state = {
            phone: '',
            username:'',
            password: '',
            confirmPassword:'',
            area: '',
            systemName:'',
        }
    }
    componentDidMount() {
        this.randomCode();
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                            systemColor:res.data.systemColor
                        }))
                        if(res.data.systemColor === 1){
                            require([`./style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`./styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`./styleGray.css`], function(list){});
                        }
                    }
                }
            )
    }
    handleInputPhone(e){
        const value  = e.target.value;
        this.setState(()=>({
            phone:value
        }));
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(value)
        if(value.length === 11){
            if(newResPhone === false){
                message.info('请检查手机号是否真实！').then()
            }else{
                fetchPost(global.constants.checkPhone,{phone:value})
                    .then(
                        res=>{
                            if(res.code === -1){
                                alert("该手机号已注册，请返回登录页直接登录")
                            }
                        })
            }
        }
    }
    handleInputUsername(e){
        const value  = e.target.value;
        this.setState(()=>({
            username:value
        }));
    }
    handleInputPassword(e){
        const value  = e.target.value;
        this.setState(()=>({
            password:value
        }));
    }
    handleConfirmPassword(e){
        const value  = e.target.value;
        this.setState(()=>({
            confirmPassword:value
        }));
    }
    handleInputArea = (e) =>{
        const value = e.target.value;
        this.setState(()=>({
            area: value
        }))
    }
    handleRegister = ()=>{
        const regPassword =/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/;
        const newResPassword = regPassword.test(this.state.password);
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(this.state.phone)
        if(this.state.username===''||this.state.phone===''||this.state.password===''
            ||this.state.confirmPassword===''
            ||this.state.area===''){
            message.error("请完善信息！").then()
        }
        else{
            if( this.state.phone.length !==11){
                message.error("请输入11位手机号码作为账号！").then()
            }else{
                if(newResPhone === false ){
                message.error("请检查该手机号是否真实！").then()
                }
                else{
                    if(this.state.password !== this.state.confirmPassword){
                    message.error("两次输入的密码不一致！").then()
                    }
                    else{
                        if(newResPassword === false){
                            message.error("请注意密码格式！").then()
                            console.log(newResPassword)
                        }else{
                            console.log(newResPassword)
                            let params = {
                                username: this.state.username,
                                phone: this.state.phone,
                                password: this.state.password,
                                area: this.state.area,
                            }
                            fetchPost(global.constants.register, params)
                                .then(
                                    res => {
                                        if(res.code === 200){
                                            let history = this.props.history;
                                            history.push('/')
                                            message.success("注册成功，请登录！").then()
                                        }else{
                                            if(res.code === -1){
                                                this.setState(()=>({
                                                        phone:'',
                                                        username:'',
                                                        password:'',
                                                        area:'',
                                                    })
                                                )
                                                message.error(res.msg).then()
                                            }
                                        }
                                    }
                                )
                                .catch(e => console.log(e))
                        }
                    }


                }
            }
            }
    }

    render() {
        return(
            <div className={"login"}>
                <div className="login-top">
                    <div className='login-header'>
                        <span className="login-header-word" >{this.state.systemName}</span>
                    </div>
                </div>
                <div className="register-background">
                    <div className="register">
                        <div className="title-line">
                            <div className="title" >注册</div>
                        </div>
                            <Form
                                {...layout}
                                name="basic"
                                initialValues={{ remember: true }}
                            >
                                <Form.Item
                                    label="账号（手机号码）"
                                    name="phone"
                                    rules={[{ required: true,message:'请输入11位手机号作为账号！',min:11,max:11}]}
                                >
                                    <Input
                                        onChange={this.handleInputPhone}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="用户名（真实姓名）"
                                    name="username"
                                    rules={[{ required: true, message: '请输入真实姓名!' }]}
                                >
                                    <Input onChange={this.handleInputUsername}/>
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    label="密码"
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入密码!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password  placeholder={'8个及以上字母、数字、特殊符号中至少两种字符组成，区分大小写'} onChange={this.handleInputPassword}/>
                                </Form.Item>
                                <Form.Item
                                    name="confirm"
                                    label="确认密码"
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: '请确认你的密码!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('两次输入的密码不一致!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password onChange={this.handleConfirmPassword}/>
                                </Form.Item>
                                <Form.Item
                                    label="地区"
                                    name="area"
                                    rules={[{ required: true, message: '请选择地区!' }]}
                                >
                                    <Input onChange={this.handleInputArea} />
                                </Form.Item>
                                <Button
                                    className="registerButton"
                                    type="primary"
                                    onClick={this.handleRegister}
                                >注册</Button>
                            </Form>
                        </div>
                </div>
            </div>
        )
    }
}
export default register;